import moment from 'moment/moment';
import Passport from '@mos-front-components/public/es/components/Passport';
import { DOCUMENT_TYPE } from '../../constants/citizenship';
import passportEditableFields from './passportEditableFields';
import { DATE_FORMAT } from '../../helpers/date';

const { FIELD_NAME } = Passport;

const passportDisabled = (params) => {
  if (params.documentType === DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF) {
    return true;
  }
  if (params[FIELD_NAME.number]) {
    return true;
  }
  if (params[FIELD_NAME.dateOfIssue]) {
    return true;
  }
  return !!params[FIELD_NAME.byWhom];
};

const getDocumentType = (data) => {
  const { birth_certificate_number, foreign_birth_certificate_number } = data;

  if (!birth_certificate_number && foreign_birth_certificate_number) {
    return DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL;
  }
  return DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF;
};

const case3 = (data, isForeignBirthdayCertificate, isBirthdayCertificateRf) => {
  const number =
    isForeignBirthdayCertificate && !isBirthdayCertificateRf
      ? data.foreign_birth_certificate_number || ''
      : data.birth_certificate_number.replace(' ', '').replace('-', '') || '';
  return {
    documentType: getDocumentType(data),
    [FIELD_NAME.byWhom]: data.birth_certificate_issued_by || '',
    [FIELD_NAME.dateOfIssue]: data.birth_certificate_issued_at || '',
    [FIELD_NAME.number]: number,
  };
};

/* eslint-disable camelcase */
const passpostChildSerializer = (data) => {
  const {
    passport_rf_number,
    passport_rf_issued_by,
    passport_rf_issued_at,
    birthdate,
  } = data;

  const hasAnyPassportFields =
    passport_rf_number || passport_rf_issued_at || passport_rf_issued_by;
  const hasBirthdayCertificate =
    !!data.birth_certificate_number || !!data.foreign_birth_certificate_number;
  const fourteenAndHalfYearsAgo = moment()
    .subtract(180, 'days')
    .subtract(14, 'years');
  const dateOfBirth = moment(birthdate, DATE_FORMAT);
  const underFourteenAndHalf = dateOfBirth.isAfter(fourteenAndHalfYearsAgo);

  const isForeignBirthdayCertificate = !!data.foreign_birth_certificate_number;
  const isBirthdayCertificateRf = !!data.birth_certificate_number;

  if (!hasAnyPassportFields && !underFourteenAndHalf) {
    const passport = {
      documentType: DOCUMENT_TYPE.PASSPORT_RF,
      [FIELD_NAME.byWhom]: '',
      [FIELD_NAME.dateOfIssue]: '',
      [FIELD_NAME.number]: '',
    };

    return {
      data: passport,
      documents: [passport],
      editableFields: passportEditableFields(passport),
      disabled: passportDisabled(passport),
    };
  }

  if (
    !hasAnyPassportFields &&
    !hasBirthdayCertificate &&
    underFourteenAndHalf
  ) {
    const passport = {
      documentType: isForeignBirthdayCertificate
        ? DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL
        : DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF,
      [FIELD_NAME.byWhom]: '',
      [FIELD_NAME.dateOfIssue]: '',
      [FIELD_NAME.number]: '',
    };

    return {
      data: passport,
      documents: [passport],
      editableFields: passportEditableFields(passport),
      disabled: passportDisabled(passport),
    };
  }

  if (underFourteenAndHalf && hasBirthdayCertificate) {
    const passport = case3(
      data,
      isForeignBirthdayCertificate,
      isBirthdayCertificateRf,
    );

    return {
      data: passport,
      documents: [passport],
      editableFields: passportEditableFields(passport),
      disabled: passportDisabled(passport),
    };
  }

  const documentType = DOCUMENT_TYPE.PASSPORT_RF;
  const byWhom = (passport_rf_issued_by || '').trim();
  const dateOfIssue = passport_rf_issued_at
    ? moment(passport_rf_issued_at, DATE_FORMAT).clone().format(DATE_FORMAT)
    : '';
  const number = (passport_rf_number || '').replace(/[^0-9]+/gi, '');

  const passport = {
    documentType,
    [FIELD_NAME.byWhom]: byWhom,
    [FIELD_NAME.dateOfIssue]: dateOfIssue,
    [FIELD_NAME.number]: number,
  };

  return {
    data: passport,
    documents: [passport],
    editableFields: passportEditableFields(passport),
    disabled: passportDisabled(passport),
  };
};
/* eslint-enable camelcase */

export default passpostChildSerializer;
